import type { ColumnDef } from "@tanstack/react-table";
import { buildTagColumn } from "@/components/Table";
import { renderEmptyCellState } from "@/components/Table/utils";
import { formatEnumLabel } from "../../_utils";
import type { CommissionProgramNode } from "../types";

export function getColumns(): ColumnDef<CommissionProgramNode, unknown>[] {
  return [
    {
      accessorKey: "name",
      header: "Name",
      size: 280,
      meta: { sortType: "text" }
    },
    {
      accessorKey: "slug",
      header: "Slug",
      size: 200,
      enableSorting: false,
      cell: ({ getValue }) => renderEmptyCellState(getValue())
    },
    buildTagColumn<CommissionProgramNode>({
      accessorKey: "status",
      header: "Status",
      size: 120,
      getTagLabel: (row) => formatEnumLabel(row.status),
      getTagType: (row) => (row.status === "ACTIVE" ? "success" : "surface"),
      getTagStyle: () => "strong"
    })
  ];
}
